import {
  Box,
  Typography,
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
  Button
} from "@material-ui/core";
import React, { ChangeEvent, useState } from "react";
import FaqSection from "./FAQSection";
import texture from "../../assets/texture-cropped.png";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import {firstPageIDs} from "../../qaIDs.json"

const useStyles = makeStyles(theme => ({
  firstPageWrapper: {
    padding: theme.spacing(6, 6, 12),
    backgroundColor: "#fff",
    [theme.breakpoints.down("md")]: {
      padding: 0
    }
  },

  gradientWrapper: {
    height: 728,
    background: "linear-gradient(103.84deg, #1329FE -17.42%, #C2185B 126.95%)",
    backdropFilter: "blur(100px)",
    borderRadius: "6px",
    overflow: "hidden",
    [theme.breakpoints.down("md")]: {
      height: 572,
      borderRadius: 0
    }
  },

  input: {
    height: theme.spacing(5.25)
  },
  inputWrapper: {
    marginBottom: theme.spacing(1.5)
  },
  helperText: {
    lineHeight: "16px",
    fontSize: "12px"
  },
  label: {
    fontWeight: 500,
    fontSize: "13px",
    lineHeight: "15px",
    display: "flex",
    color: "#4D4D50",
    marginBottom: theme.spacing(0.75)
  },
  titleWrapper: {
    color: "#fff",
    marginBottom: theme.spacing(6),
    "& h4": {
      marginTop: theme.spacing(2)
    }
  },

  btn: {
    marginTop: theme.spacing(0.5),
    fontWeight: "normal",
    fontSize: "14px",
    height: "44px"
  }
}));

export default function FirstPage() {
  const classes = useStyles();

  const [inputValues, setInputValues] = useState({
    trackingNumber: "",
    postalCode: ""
  });

  const [errors, setErrors] = useState({
    trackingNumber: ""
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValues((prevValues: any) => ({
      ...prevValues,
      [e.target.name]: e.target.value
    }));
  };

  const { t } = useTranslation();

  console.log(t);

  return (
    <div>
      <div className={classes.firstPageWrapper}>
        <div className={classes.gradientWrapper}>
          <Box
            sx={{
              height: "100%",
              backgroundImage: "url(" + texture + ")",
              display: "flex",
              backgroundSize: "200px",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <Box maxWidth={490} px={3} width="100%">
              <div className={classes.titleWrapper}>
                <Typography variant="h2" id={firstPageIDs.firstPageTrackTrace}>{t("Track & Trace")}</Typography>
                <Typography variant="h4" id={firstPageIDs.firstPageTrackShipment} >{t("Track your shipment")}</Typography>
              </div>

              <Box
                sx={{ backgroundColor: "#ffffff", borderRadius: "6px" }}
                px={5}
                pt={5}
                pb={6}
              >
                <div className={clsx(classes.inputWrapper)}>
                  <InputLabel
                    className={classes.label}
                    htmlFor={firstPageIDs.firstPageTrackingNumber}
                  >
                    {t("Tracking number")}
                  </InputLabel>
                  <FormControl
                    sx={{
                      width: "100%"
                    }}
                  >
                    <OutlinedInput
                      id={firstPageIDs.firstPageTrackingNumber}
                      className={classes.input}
                      fullWidth
                      value={inputValues.trackingNumber}
                      onChange={handleChange}
                      name="trackingNumber"
                    />
                    <FormHelperText error className={classes.helperText}>
                      {t(errors.trackingNumber) || " "}
                    </FormHelperText>
                  </FormControl>
                </div>
                <div className={clsx(classes.inputWrapper)}>
                  <InputLabel
                    className={classes.label}
                    htmlFor={firstPageIDs.firstPagePostalCode}
                  >
                    {t("Postal code")}
                  </InputLabel>
                  <FormControl
                    sx={{
                      width: "100%"
                    }}
                  >
                    <OutlinedInput
                      id={firstPageIDs.firstPagePostalCode}
                      className={classes.input}
                      fullWidth
                      value={inputValues.postalCode}
                      onChange={handleChange}
                      name="postalCode"
                    />
                    <FormHelperText className={classes.helperText}>
                      {" "}
                    </FormHelperText>
                  </FormControl>
                </div>

                <Button
                  fullWidth
                  variant="contained"
                  disableElevation
                  id={firstPageIDs.firstPageSearchButton}
                  onClick={() => {
                    if (inputValues.trackingNumber) {
                      setErrors({
                        ...errors,
                        trackingNumber: ""
                      });
                      window.location.href =
                        process.env.REACT_APP_TT_URL +
                        `?tracking_number=${inputValues.trackingNumber}&postal_code=${inputValues.postalCode}`;
                    } else {
                      setErrors({
                        ...errors,
                        trackingNumber: "Please fill in tracking number"
                      });
                    }
                  }}
                  className={classes.btn}
                >
                  {t("Search")}
                </Button>
              </Box>
            </Box>
          </Box>
        </div>
      </div>
      {/* <FaqSection /> */}
    </div>
  );
}
